exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/degree-description.js-WebpackMultiOutput";